import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

/*
  Function that bootstraps the whole react application
  and renders into browser
*/

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
